var _defs, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12935_43966",
    x1: 8.04785,
    y1: 0,
    x2: 8.04785,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B4DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E9EFF"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.04785,
    cy: 8,
    r: 8,
    fill: "url(#paint0_linear_12935_43966)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8478 7.47248H8.18722V9.31863H10.6702C10.3383 10.2021 9.5283 10.7428 8.29345 10.7428C6.48764 10.7428 5.37228 9.59556 5.37228 8.02632C5.37228 6.40435 6.54075 5.25709 8.10755 5.25709C9.15652 5.25709 9.99303 5.73182 10.3781 6.33841L12.1839 5.30984C11.4005 4.07028 9.90008 3.19995 8.12083 3.19995C5.38556 3.19995 3.2478 5.33622 3.2478 8.01314C3.2478 10.6637 5.34573 12.8 8.26689 12.8C10.8694 12.8 12.8478 11.0857 12.8478 8.26369V7.47248Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoCoin);
export default __webpack_public_path__ + "static/media/goCoin.68e002621aa86e25efbfb49742af46b7.svg";
export { ForwardRef as ReactComponent };